import styled from 'styled-components';
import { mediaQueries } from "../../utils/device";
import BlocketSymbolImage from "../BlocketSymbol/BlocketSymbol.svg.js";
import BlocketLogoImage from "../BlocketLogo/BlocketLogo.svg.js";
import IsAppRouteLink from "./IsAppRouteLink";
var BlocketLogoLink = styled(IsAppRouteLink).withConfig({
  displayName: "BlocketLogoLink",
  componentId: "sc-1mwdei8-0"
})(["display:block;width:40px;height:40px;background:url(", ") no-repeat left;background-size:contain;@media ", "{width:150px;background:url(", ") no-repeat left;}"], BlocketSymbolImage, mediaQueries.medium, BlocketLogoImage);
export default BlocketLogoLink;
//# sourceMappingURL=BlocketLogoLink.js.map